// The clipboard controller allows arbitrary text or markup to be copied onto
// the users clipboard. It must contain at least one element with
// data-clipboard-target="content" and data-mime-type="..." attributes, and a
// <button data-action="clipboard#copy">...</button> with two labels. Clicking
// the button will loop through all the content targets and based on their
// data-mime-type will add their innerHTML to the clipboard under that content
// type. The button contains two labels: one to display initially and one to
// display on success. These labels can also be svg icons.
//
// Example:
//
// <div data-controller="clipboard">
//   <div data-clipboard-target="content" data-mime-type="text/plain">
//     Hello, world!
//   </div>
//   <div data-clipboard-target="content" data-mime-type="text/html">
//     <em>Hello,</em> <strong>world!</strong>
//   </div>
//   <button data-action="clipboard#copy">
//     <span class="clipboard__copy-label">Copy Details</span>
//     <span class="clipboard__success-label">Copied!</span>
//   </button>
// </copy-content>
//
// See also: app/javascript/stylesheets/_clipboard.css
//
// Reference:
//
// https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  async copy(_event) {
    const clipboardData = this.contentTargets.reduce((accum, copyable) => {
      const type = copyable.dataset.mimeType;
      accum[type] = copyable.innerHTML;
      return accum;
    }, {});
    const clipboardItem = new ClipboardItem(clipboardData, {
      presentationStyle: "inline",
    });
    await navigator.clipboard.write([clipboardItem]).then(() => {
      this.element.dataset.statusSuccess = true;
      window.setTimeout(() => {
        delete this.element.dataset.statusSuccess;
      }, 2000);
    });
  }
}
